import { v1 as uuid } from 'uuid';
import { useProgressNotifierContext } from '@trukt/ui/ProgressNotifierContext';
import { getErrorMessage } from '@trukt/portal-utils/getErrorMessage';
import { CancelExportReportRequest, truktApi } from '@api';
import { useMutation } from '@tanstack/react-query';

export const useCancelExportReportMutation = () => {
  const progressNotifierContext = useProgressNotifierContext();

  return useMutation({
    mutationFn: (request: CancelExportReportRequest) => {
      return truktApi.report.exports.cancel(request);
    },

    onMutate: () => {
      const progressNotifierId = uuid();
      progressNotifierContext.dispatchNotification({
        id: progressNotifierId,
        label: 'Canceling report export.',
      });

      return { progressNotifierId };
    },

    onError: (error, _params, context) => {
      if (!context?.progressNotifierId) return;

      progressNotifierContext.updateNotification(context.progressNotifierId, {
        errorMessage: getErrorMessage(error),
        isError: true,
      });
    },

    onSuccess: (_data, _params, context) => {
      if (!context?.progressNotifierId) return;

      progressNotifierContext.updateNotification(context.progressNotifierId, {
        isSuccess: true,
      });
    },
  });
};
